<script lang="ts">
    import {colorMap, MatColor, OfferItem} from "../../entities/OfferItem";
    import {metalColors, fabricColors} from "../../entities/OfferItem";
    export let updateFormData: Function;
    export let currentItem: OfferItem;
    let colorPickerState = 0
    function setState(state: number) {
        colorPickerState = state
    }
    function setColor(color: MatColor) {
        if (colorPickerState === 1) {
            if (currentItem.frameColor === color)
                return
            updateFormData({
                frameColor: color
            })
        }
        else {
            if (currentItem.panelColor === color)
                return
            updateFormData({
                panelColor: color
            })
        }
    }
    function returnHexColor(color: MatColor) {
        return `#${colorMap[color].substr(2)}`
    }
</script>
{#if colorPickerState === 0}
    <div class="flex justify-around w-full h-full items-center p-4">
        <span class="p-2 text-sm md:text-base md:p-4 bg-blue-800 rounded-xl hover:bg-blue-600 transition cursor-pointer" on:click={() => setState(1)}>Vázszín kiválasztás</span>
        <span class="p-2 text-sm md:text-base md:p-4 bg-blue-800 rounded-xl hover:bg-blue-600 transition cursor-pointer" on:click={() => setState(2)}>Lamellaszín kiválasztás</span>
    </div>
{/if}
{#if colorPickerState === 1 || colorPickerState === 2 }
    <div class="p-1 flex space-x-2 items-center text-white transition hover:text-yellow-400 pl-4 cursor-pointer" on:click={() => setState(0)}>
        <svg class="w-5 h-5 fill-current" version="1.1" id="back" xmlns="http://www.w3.org/2000/svg"  x="0px" y="0px"
             viewBox="0 0 443.52 443.52" style="enable-background:new 0 0 443.52 443.52;" xml:space="preserve">
	        <g>
                <path d="M143.492,221.863L336.226,29.129c6.663-6.664,6.663-17.468,0-24.132c-6.665-6.662-17.468-6.662-24.132,0l-204.8,204.8
                    c-6.662,6.664-6.662,17.468,0,24.132l204.8,204.8c6.78,6.548,17.584,6.36,24.132-0.42c6.387-6.614,6.387-17.099,0-23.712
                    L143.492,221.863z"/>
	        </g>
        </svg>
        <span>
            Vissza
        </span>
    </div>
    {#if currentItem.measuredModel.model.id < 4}
        {#each metalColors as value}
            <div class="inline-flex relative text-center m-2 inline-flex">
                <input type="checkbox" name="extra" class="extra" id="{value}"
                       checked={colorPickerState === 1 ? currentItem.frameColor === MatColor[value] : currentItem.panelColor === MatColor[value]}
                       on:click={() => setColor(MatColor[value])}/>
                <label class="cursor-pointer mx-3 img-label" for="{value}">
                    <div class="h-16 w-16 rounded-2xl shadow-lg selected bg-white" style="background-color: {returnHexColor(MatColor[value])}"></div>
                    <span class="absolute bottom-0 left-0 py-1 bg-primary-100 text-white rounded text-sm w-full rounded-br-xl rounded-bl-xl">{MatColor[value]}</span>
                </label>
            </div>
        {/each}
    {/if}
    {#if currentItem.measuredModel.model.id > 3}
        {#if colorPickerState === 1}
            {#each metalColors as value}
                <div class="inline-flex relative text-center m-2 inline-flex">
                    <input type="checkbox" name="extra" class="extra" id="{value}"
                           checked={colorPickerState === 1 ? currentItem.frameColor === MatColor[value] : currentItem.panelColor === MatColor[value]}
                           on:click={() => setColor(MatColor[value])}/>
                    <label class="cursor-pointer mx-3 img-label" for="{value}">
                        <div class="h-16 w-16 rounded-2xl shadow-lg selected bg-white" style="background-color: {returnHexColor(MatColor[value])}"></div>
                        <span class="absolute bottom-0 left-0 py-1 bg-primary-100 text-white rounded text-sm w-full rounded-br-xl rounded-bl-xl">{MatColor[value]}</span>
                    </label>
                </div>
            {/each}
        {/if}
        {#if colorPickerState === 2}
            {#each fabricColors as value}
                <div class="inline-flex relative text-center m-2 inline-flex">
                    <input type="checkbox" name="extra" class="extra" id="{value}"
                           checked={colorPickerState === 1 ? currentItem.frameColor === MatColor[value] : currentItem.panelColor === MatColor[value]}
                           on:click={() => setColor(MatColor[value])}/>
                    <label class="cursor-pointer mx-3 img-label" for="{value}">
                        <div class="h-16 w-16 rounded-2xl shadow-lg selected bg-white" style="background-color: {returnHexColor(MatColor[value])}"></div>
                        <span class="absolute bottom-0 left-0 py-1 bg-primary-100 text-white rounded text-sm w-full rounded-br-xl rounded-bl-xl">{MatColor[value]}</span>
                    </label>
                </div>
            {/each}
        {/if}
    {/if}
{/if}